import axios from "axios";

// The sale-alerts unsubscribe endpoints live in CORE-API — a different service
// from REACT_APP_API_BASE_URL (which points at user-management-api). Use the
// core-api base, which already includes the "/api" prefix. The endpoints are
// public + token-gated, so no auth header is required.
const CORE_API = (process.env.REACT_APP_CORE_API_BASE_URL || "").replace(
  /\/$/,
  ""
);

const headers = { Accept: "application/json", "Content-Type": "application/json" };

export const unsubscribeAPI = {
  // Validate the token and return { valid, email }.
  getInfo: async (token) => {
    const res = await axios.get(
      `${CORE_API}/sale-alerts/unsubscribe/${encodeURIComponent(token)}`,
      { headers }
    );
    return res.data?.data;
  },

  // Perform the unsubscribe. Returns { status, email }.
  confirm: async (token) => {
    const res = await axios.post(
      `${CORE_API}/sale-alerts/unsubscribe/${encodeURIComponent(token)}`,
      {},
      { headers }
    );
    return res.data?.data;
  },
};
